<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <div class="superadmin-dashboard-area edit-area">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="registered-product-item w-half">
                            <router-link v-if="!hasRedirect" :to="{name: 'SuperadminCustomers'}" class="mb-3 inline-block"
                                ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                            >
                            <router-link v-else :to="{name: $route.query.redirect, params: {id: $route.query.id}}" class="mb-3 inline-block"
                                ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                            >

                            <h3 class="mb-4">Add New User</h3>
                            <ul>
                                <li>
                                    <span class="semibold mb-2">Select the type of user you want to create</span>
                                    <custom-check-box
                                        name="role"
                                        :form="form"
                                        :options="[
                                            {name: 'Reseller', value: 'reseller'},
                                            {name: 'Customer', value: 'customer'},
                                            {name: 'Dewhot Depot', value: 'distributor'}
                                        ]"
                                    />
                                </li>

                                <li v-if="form.role != 'customer'">
                                    <span class="semibold">Company</span>
                                    <span><input type="text" v-model="form.company" name="company" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">First Name</span>
                                    <span><input type="text" v-model="form.fname" name="fname" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Last name</span>
                                    <span><input type="text" v-model="form.lname" name="lname" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Email</span>
                                    <span><input type="text" v-model="form.email" name="email" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Address</span>
                                    <em class="notice">( Please select from autosuggestion )</em>
                                    <!-- <span><input type="text" v-model="form.address" name="address" class="form-control" /></span> -->
                                    <span>
                                        <gmap-autocomplete
                                            id="user_address"
                                            autocomplete="nope"
                                            class="form-control"
                                            large
                                            name="address"
                                            placeholder="Once you start typing google will autosuggest."
                                            :select-first-on-enter="true"
                                            :componentRestrictions="{country: ['ZA']}"
                                            @place_changed="setPlace"
                                            @keyup="resetPlace"
                                        >
                                        </gmap-autocomplete>
                                    </span>

                                    <div class="address-info-wrap" v-if="form.address">
                                        <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                        <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                        <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                        <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                                    </div>
                                </li>

                                <li>
                                    <span class="semibold">Complex/Building + Unit</span>
                                    <span
                                        ><input type="text" v-model="form.complex_building_unit" name="complex_building_unit" class="form-control"
                                    /></span>
                                </li>

                                <li v-if="form.role == 'reseller'">
                                    <ul>
                                        <li :class="form.has_website == 1 ? '' : 'border-b-1 pb-2'">
                                            <span class="semibold mb-2">Has website?</span>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model.number="form.has_website"
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="haveWebsite"
                                                    id="website_yes"
                                                    value="1"
                                                />
                                                <label class="form-check-label" for="website_yes">Yes</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model.number="form.has_website"
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="haveWebsite"
                                                    id="website_no"
                                                    value="0"
                                                />
                                                <label class="form-check-label" for="website_no">No</label>
                                            </div>
                                            <ul>
                                                <li v-if="form.has_website == 1" class="website-holder mt-2 mb-0">
                                                    <span class="website-prefix dark">https://</span>
                                                    <input type="text" v-model="form.website" placeholder="eg: example.com" class="form-control" />
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>

                                <li>
                                    <span class="semibold">Mobile</span>
                                    <span><input type="number" v-model="form.mobile" name="mobile" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Password</span>
                                    <span><input type="password" v-model="form.password" name="mobile" class="form-control" /></span>
                                </li>

                                <li v-if="form.role == 'reseller'">
                                    <span class="semibold">Reseller Type</span>
                                    <select v-model="form.reseller_type" class="baseline-input">
                                        <option value="">--Select--</option>
                                        <option :value="resellerType.value" v-bind:key="resellerType.value" v-for="resellerType in resellerTypes">
                                            {{ resellerType.label }}
                                        </option>
                                    </select>
                                </li>

                                <li v-if="form.role == 'reseller'">
                                    <span class="semibold">Select Depo</span>
                                    <select v-model="form.distributor_id" class="baseline-input">
                                        <option value="">--Select--</option>
                                        <option :value="distributor.id" v-bind:key="distributor.id" v-for="distributor in distributor_list">
                                            {{ distributor.company }}
                                        </option>
                                    </select>
                                </li>

                                <li v-if="form.role != 'customer'">
                                    <span class="semibold">Select Region</span>
                                    <select v-model="form.region" class="baseline-input">
                                        <option value="">--Select--</option>
                                        <option :value="region" v-bind:key="region" v-for="region in regions">{{ region }}</option>
                                    </select>
                                </li>

                                <li v-if="form.role == 'distributor'">
                                    <p>
                                        <span class="semibold">Depot Technician</span>
                                        <em style="font-size: 11px">Email address separated by "," comma</em>
                                        <input
                                            class="baseline-input"
                                            name="ccem"
                                            v-model="form.tech_emails"
                                            type="text"
                                            autocomplete="new-em"
                                            id="cc_em"
                                        />
                                    </p>
                                </li>

                                <li class="inline">
                                    <label class="d-flex">
                                        <input
                                            type="checkbox"
                                            v-model="form.send_user_email"
                                            name="send_user_email"
                                            style="width: auto; display: inline-block"
                                        />
                                        <span class="ml-2">Send user email about his account</span>
                                    </label>
                                </li>
                                <li>
                                    <button class="btn btn-primary mt-3 px-5" @click.prevent="addSuperadminCustomer()">+ ADD</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';

export default {
    name: 'SuperadminCustomerAdd',
    data() {
        return {
            roles: ['reseller', 'customer', 'distributor'],
            distributor_list: [],
            form: {
                fname: '',
                lname: '',
                email: '',
                company: '',
                address: '',
                website: '',
                has_website: 0,
                complex_building_unit: '',
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                mobile: '',
                tech_emails: '',
                reseller_type: '',
                role: 'reseller',
                distributor_id: '',
                region: '',
                password: ''
            }
        };
    },

    watch: {
        'form.mobile'(val, oldval) {
            if (val.length > 10) {
                this.form.mobile = oldval;
            }
        },

        'form.role'() {
            this.form.has_website = this.form.role == 'reseller' ? 1 : 0;
            if (this.form.role != 'reseller') {
                this.form.website = '';
            }
        },

        'form.has_website'() {
            if (!this.form.has_website) {
                this.form.website = '';
            }
        }
    },

    computed: {
        regions() {
            return Env.regions;
        },
        resellerTypes() {
            return Env.resellerTypes;
        },
        hasRedirect() {
            if (this.$route.query.redirect) {
                return true;
            }
            return false;
        }
    },

    mounted() {
        this.fetchDistributor();
    },

    methods: {
        /**
         * autocomplete set
         */
        setPlace: async function (addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            // console.log(addressData.formatted_address)
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
        },

        resetPlace: function () {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        },

        /**
         * Fetch distributors
         */
        fetchDistributor() {
            const url = `${Env.baseUrl}/get-distributors`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.distributor_list = res.data.payload;
                })
                .catch((err) => {
                    this.distributor_list = [];
                });
        },

        back() {
            if (this.$route.query.redirect && this.$route.query.id) {
                this.$router.push({
                    name: this.$route.query.redirect,
                    id: this.$route.query.id
                });
            } else {
                this.$router.push({
                    name: 'SuperadminCustomers'
                });
            }
        },

        async addSuperadminCustomer() {
            this.spinner(true);
            const url = `${Env.baseUrl}/superadmin/users/create`;
            AuthApis.postApi(url, this.form)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully added.'
                    });

                    if (this.hasRedirect) {
                        this.$router.push({
                            name: this.$route.query.redirect,
                            params: {
                                id: this.$route.query.id
                            }
                        });
                    } else {
                        this.$router.push({name: 'SuperadminCustomers'});
                    }
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        }
    }
};
</script>
